import { Get, getAPIUrl } from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const EnquiryEndpoint = {
  getEnquiryData: `/admin/content/getEnquires`,
};

export const getEnquiryData = (param = "") => {
  const url = getAPIUrl(EnquiryEndpoint.getEnquiryData, param);
  return Get(HomePageService, url, true);
};
